import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getCurrentLanguage } from 'utils/translation';

import { GetStarted } from '../../styles';

const Feature = ({ name, color, isGetStarted, isInverted }) => {
  const { t } = useTranslation();
  const currentLanguage = getCurrentLanguage();

  return (
    <div className="content-wrap">
      <div className={`content content--layout ${!isInverted ? 'content--layout-2' : 'content--layout-1'}`}>
        <img
          className="content__img"
          src={`/assets/images/features/${name.toLowerCase()}_${currentLanguage}.png`}
          alt={name}
          style={{ marginTop: isGetStarted ? '25px' : '0' }}
        />
        <h3 className="content__title" style={{ color }}>{t(`FEATURES.${name}.NAME`)}</h3>
        <p className="content__desc">{t(`FEATURES.${name}.DESCRIPTION`)}</p>
        {isGetStarted && <GetStarted isInverted>{t('FEATURES.COMMON.GET_STARTED')}</GetStarted>}
      </div>
    </div>
  );
};

Feature.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  isGetStarted: PropTypes.bool,
  isInverted: PropTypes.bool,
};

export default Feature;
